import { render } from "./validate.vue?vue&type=template&id=64fc25bb&scoped=true&lang=pug"
import script from "./validate.vue?vue&type=script&setup=true&lang=js"
export * from "./validate.vue?vue&type=script&setup=true&lang=js"

import "./validate.vue?vue&type=style&index=0&id=64fc25bb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fc25bb"]])

export default __exports__